import LandingMainPitchSection from './LandingMainPitchSection';

export default LandingMainPitchSection;